var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      staticClass: "cash-flow-report-mapping-card",
      attrs: { title: _vm.sectionTitle }
    },
    [
      _c(
        "a",
        { attrs: { slot: "extra" }, slot: "extra" },
        [
          _c("a-icon", {
            staticClass: "cash-flow-report-mapping-card__icon",
            attrs: { type: _vm.sectionIcon }
          })
        ],
        1
      ),
      _vm._l(_vm.mappings, function(mapping, index) {
        return _c("CashFlowReportMappingRow", {
          key: mapping.id,
          attrs: {
            mapping: mapping,
            "account-options": _vm.accountOptions,
            "initially-editing": index === _vm.newlyAddedIndex
          },
          on: {
            save: function($event) {
              return _vm.$emit(
                "save",
                Object.assign({}, { section: _vm.title, index: index }, $event)
              )
            },
            delete: function($event) {
              return _vm.$emit("delete", { section: _vm.title, index: index })
            },
            cancel: function($event) {
              return _vm.$emit("cancel", { section: _vm.title, index: index })
            }
          }
        })
      }),
      _c(
        "a-row",
        {
          staticClass: "cash-flow-report-mapping-card__add-row-container",
          attrs: { type: "flex", justify: "end" }
        },
        [
          _c(
            "a-button",
            {
              attrs: { icon: "plus" },
              on: {
                click: function($event) {
                  return _vm.$emit("add-row", _vm.title)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("lbl_add_row")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }